import axios from "axios";
import { SERVER_URL } from "../constants/server";

export const authorize = (token) =>
  axios.post(SERVER_URL + "/api/login/authorize", { token });
